// extracted by mini-css-extract-plugin
module.exports = {"richTextDocument":"RichTextDocument_richTextDocument__doNzI","container":"RichTextDocument_container__8FA4t global_grid__4e_JW","content":"RichTextDocument_content__IzMk7"};